"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataHooks = void 0;
var comp = 'accordion-item';
var dataHooks = {
  tooltip: "".concat(comp, "-tooltip"),
  header: "".concat(comp, "-header"),
  children: "".concat(comp, "-children")
};
exports.dataHooks = dataHooks;